<template>
	<div class="eno-layout">
		<enoHeader></enoHeader>
		<transition name="el-fade-in">
			<mainPage v-show="pageLoad"></mainPage>
		</transition>
	</div>
</template>

<script>
	import enoHeader from '../header/header'
	import mainPage from '../mainPage/mainPage'
	export default {
		name: 'layout',
		components: {enoHeader, mainPage },
		data() {
			return {
				pageLoad:false
			}
		},
		created(){
			setTimeout(()=>{
				this.pageLoad = true
			}, 100)
		},
		mounted() {
			// window.addEventListener("scroll", this.changeHeadBg);
		},
		methods: {
		},

	}
</script>

<style lang="less">
	.eno-layout{
		overflow: hidden;
	}
</style>